var React = require('react');

function InfoConciergeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","cx":"32","cy":"32","r":"30","key":0}),React.createElement("path",{"d":"M35 43a3 3 0 0 1-6 0V30a3 3 0 0 1 6 0v13zm-3-19a3 3 0 1 1 0-6 3 3 0 0 1 0 6z","fill":"currentColor","key":1})]));
}

InfoConciergeInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = InfoConciergeInline;

InfoConciergeInline.default = InfoConciergeInline;
